import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * DiceDisplay Component
 * Displays the current dice values with selection capability
 *
 * @param {object} dice - Dice values object {white1, white2, red, yellow, green, blue}
 * @param {number} selectedWhiteDie - Which white die is selected (1 or 2)
 * @param {string} selectedColor - Which color die is selected
 * @param {object} activeDice - Object indicating which colored dice are active
 * @param {string} turnPhase - Current turn phase
 * @param {string} currentPlayer - Name of active player
 * @param {string} playerName - Current user's name
 * @param {function} onSelectDie - Callback when a die is selected
 */
const DiceDisplay = ({
  dice,
  selectedWhiteDie,
  selectedColor,
  activeDice,
  turnPhase,
  currentPlayer,
  playerName,
  onSelectDie
}) => {
  const { t } = useLanguage();

  const canSelectDice = turnPhase === 'colorDice' && currentPlayer === playerName;

  return (
    <div className="dice-section">
      <div className="section-header">
        <h2>{t('common.dice')}</h2>
      </div>
      <div className="dice-row-container">
        {/* White dice row */}
        <div className="dice-row">
          <div
            className={`die white ${selectedWhiteDie === 1 ? 'selected' : ''}`}
            onClick={() => canSelectDice && onSelectDie('white', 1)}
            style={{ cursor: canSelectDice ? 'pointer' : 'default' }}
          >
            <div className="die-label">{t('dice.white1')}</div>
            <div className="die-value">{dice.white1 || '-'}</div>
          </div>
          <div
            className={`die white ${selectedWhiteDie === 2 ? 'selected' : ''}`}
            onClick={() => canSelectDice && onSelectDie('white', 2)}
            style={{ cursor: canSelectDice ? 'pointer' : 'default' }}
          >
            <div className="die-label">{t('dice.white2')}</div>
            <div className="die-value">{dice.white2 || '-'}</div>
          </div>

          {/* Colored dice - all in one row */}
          <div
            className={`die red ${selectedColor === 'red' ? 'selected' : ''} ${!activeDice.red ? 'inactive' : ''}`}
            onClick={() => canSelectDice && onSelectDie('red')}
            style={{ cursor: canSelectDice ? 'pointer' : 'default' }}
          >
            <div className="die-label">{t('dice.red')}</div>
            <div className="die-value">{dice.red || '-'}</div>
          </div>
          <div
            className={`die yellow ${selectedColor === 'yellow' ? 'selected' : ''} ${!activeDice.yellow ? 'inactive' : ''}`}
            onClick={() => canSelectDice && onSelectDie('yellow')}
            style={{ cursor: canSelectDice ? 'pointer' : 'default' }}
          >
            <div className="die-label">{t('dice.yellow')}</div>
            <div className="die-value">{dice.yellow || '-'}</div>
          </div>
          <div
            className={`die green ${selectedColor === 'green' ? 'selected' : ''} ${!activeDice.green ? 'inactive' : ''}`}
            onClick={() => canSelectDice && onSelectDie('green')}
            style={{ cursor: canSelectDice ? 'pointer' : 'default' }}
          >
            <div className="die-label">{t('dice.green')}</div>
            <div className="die-value">{dice.green || '-'}</div>
          </div>
          <div
            className={`die blue ${selectedColor === 'blue' ? 'selected' : ''} ${!activeDice.blue ? 'inactive' : ''}`}
            onClick={() => canSelectDice && onSelectDie('blue')}
            style={{ cursor: canSelectDice ? 'pointer' : 'default' }}
          >
            <div className="die-label">{t('dice.blue')}</div>
            <div className="die-value">{dice.blue || '-'}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiceDisplay;
